import { UntypedFormGroup } from "@angular/forms";
import moment from "moment";
import { CONSTANT } from "src/app/constant";
import { CandidateSessionConfiguration } from "src/app/models/models";
import { buildFlightSimulatorDetailsPayload } from "../../shared-v2/flight-simulator-details.payload";
import { Ets1SessionConfigItem } from "src/app/cbta-web/ets1/session/ets1-session-layout.utils";
import { extractCandidateSessionConfigurations } from "../../shared-v2/utils/session-form.utils";

export interface Ts1PreviewCandidateDetails {
	trainingDate: string;
	sessionConfigurations: CandidateSessionConfiguration[];
	name: string;
	rank: string;
	staffNumber: string;
	pilotProfile: string;
	licenseNo: string;
	licenseType: string;
	licenseExpiryDate: string;
	flightSimulatorDetails: ReturnType<typeof buildFlightSimulatorDetailsPayload>;
	ets1SessionCatalog?: Ets1SessionConfigItem[];
	ets1SelectedSessionCodes?: string[];
	ets1SessionRemarksByCode?: Record<string, string>;
	ets1SessionGroupCode?: string;
}

function displayOption(val: unknown): string {
	if (val == null || val === "") return "-";
	if (typeof val === "string") return val;
	if (typeof val === "object" && val !== null) {
		const o = val as { description?: string; code?: string };
		return (o.description ?? o.code ?? "-").toString();
	}
	return String(val);
}

function formatPreviewDate(value: unknown, format = "DD MMMM YYYY"): string {
	if (!value) return "-";
	const m = moment(value);
	return m.isValid() ? m.format(format) : "-";
}

export function extractSessionConfigurationsFromCandidate(
	candidateControl: UntypedFormGroup,
	sessionKeys: any[],
): CandidateSessionConfiguration[] {
	return extractCandidateSessionConfigurations(
		candidateControl.get("sessionDetails")?.getRawValue(),
		candidateControl.get("sessionRemarks")?.getRawValue(),
		sessionKeys,
	);
}

export function buildTs1PreviewCandidateDetails(
	candidateControl: UntypedFormGroup,
	sessionKeys: any[],
	trainingDate: unknown,
): Ts1PreviewCandidateDetails {
	const raw = candidateControl.getRawValue();
	const fs = candidateControl.get("flightSimulatorDetails")?.getRawValue() ?? {};

	return {
		trainingDate: formatPreviewDate(trainingDate),
		sessionConfigurations: extractSessionConfigurationsFromCandidate(candidateControl, sessionKeys),
		name: (raw?.name ?? "-").toString(),
		rank: displayOption(raw?.rank),
		staffNumber: (raw?.staffNumber ?? "-").toString(),
		pilotProfile: displayOption(raw?.pilotProfile),
		licenseNo: (raw?.licenseNo ?? "-").toString(),
		licenseType: displayOption(raw?.licenseType),
		licenseExpiryDate: raw?.licenseNo
			? formatPreviewDate(raw?.licenseExpiryDate, CONSTANT.DATE_FORMAT.DISPLAY_DATE_FORMAT)
			: "-",
		flightSimulatorDetails: buildFlightSimulatorDetailsPayload(fs),
	};
}
